<template>
    <div class="group relative">
        <svg
            viewBox="0 0 49 115"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="112"
            class="transition-transform duration-300 group-hover/menuItem:scale-125">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.6 61H42C44.7614 61 47 58.7614 47 56L47 10.6038C47 8.45164 45.6229 6.54095 43.5811 5.86038L30.2945 1.43151C29.447 1.149 28.5393 1.09873 27.6657 1.28591L4.95235 6.15307C2.647 6.64707 1 8.68439 1 11.0421V56C1 58.7614 3.23858 61 6 61L28.6 61Z"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M29 1V61"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M33 29.8428C33 28.5416 34.2231 27.5868 35.4854 27.9023L41.4854 29.4023C42.3755 29.625 43 30.4252 43 31.3428V45C43 46.1046 42.1046 47 41 47H35C33.8954 47 33 46.1046 33 45V29.8428Z"
                fill="white"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M33 39L43 40"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M15.5 27C17.6446 27 19.747 28.4222 21.3652 31.0625C22.9731 33.686 24 37.3738 24 41.5C24 45.6262 22.9731 49.314 21.3652 51.9375C19.747 54.5778 17.6446 56 15.5 56C13.3554 56 11.253 54.5778 9.63477 51.9375C8.02688 49.314 7 45.6262 7 41.5C7 37.3738 8.02688 33.686 9.63477 31.0625C11.253 28.4222 13.3554 27 15.5 27Z"
                fill="white"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M15 11C15.6662 11 16.3914 11.4055 16.9961 12.3125C17.596 13.2125 18 14.5131 18 16C18 17.4869 17.596 18.7875 16.9961 19.6875C16.3914 20.5945 15.6662 21 15 21C14.3338 21 13.6086 20.5945 13.0039 19.6875C12.404 18.7875 12 17.4869 12 16C12 14.5131 12.404 13.2125 13.0039 12.3125C13.6086 11.4055 14.3338 11 15 11Z"
                fill="white"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M17 37C17.6662 37 18.3914 37.4055 18.9961 38.3125C19.596 39.2125 20 40.5131 20 42C20 43.4869 19.596 44.7875 18.9961 45.6875C18.3914 46.5945 17.6662 47 17 47C16.3338 47 15.6086 46.5945 15.0039 45.6875C14.404 44.7875 14 43.4869 14 42C14 40.5131 14.404 39.2125 15.0039 38.3125C15.6086 37.4055 16.3338 37 17 37Z"
                fill="white"
                stroke="currentColor"
                stroke-width="2" />
            <line
                x1="25"
                y1="60"
                x2="25"
                y2="113"
                stroke="currentColor"
                stroke-width="2" />
            <line
                x1="24.8555"
                y1="75.5178"
                x2="1.8555"
                y2="113.518"
                stroke="currentColor"
                stroke-width="2" />
            <line
                x1="25.4"
                y1="103.8"
                x2="13.4"
                y2="94.8"
                stroke="currentColor"
                stroke-width="2" />
            <line
                y1="-1"
                x2="15"
                y2="-1"
                transform="matrix(0.8 -0.6 -0.6 -0.8 24 103)"
                stroke="currentColor"
                stroke-width="2" />
            <line
                y1="-1"
                x2="44.4185"
                y2="-1"
                transform="matrix(0.517803 0.8555 0.8555 -0.517803 26 75)"
                stroke="currentColor"
                stroke-width="2" />
        </svg>

        <svg
            viewBox="0 0 41 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="41"
            height="49"
            class="absolute top-10 opacity-0 transition-all duration-300 group-hover/menuItem:animate-waves-sound-left group-hover/menuItem:opacity-100">
            <path
                d="M33.772 33.9497C33.772 33.9497 28.6013 30.7944 28.6557 23.5228C28.7101 16.2512 33.9274 13.1736 33.9274 13.1736"
                stroke="#743FDA"
                stroke-width="2" />
            <path
                d="M24.2175 38.2065C24.2175 38.2065 19.0604 33.2354 19.1368 23.0185C19.2133 12.8015 24.4442 7.90809 24.4442 7.90809"
                stroke="#743FDA"
                stroke-width="2" />
            <path
                d="M15.522 43.3345C15.522 43.3345 9.51242 36.5872 9.61771 22.5131C9.723 8.43894 15.8328 1.78231 15.8328 1.78231"
                stroke="#743FDA"
                stroke-width="2" />
        </svg>
    </div>
</template>

<script lang="ts" setup></script>
